export class StageRouter {
    #listener;
    #handlePopState;
    #currentPath = "/settings";
    #started = false;
    constructor(listener) {
        this.#listener = listener;
        this.#handlePopState = () => {
            this.#setCurrent(normalizePath(location.pathname), false);
        };
    }
    currentPath() {
        return this.#currentPath;
    }
    navigate(path, options = {}) {
        const next = normalizePath(path);
        if (next === this.#currentPath) {
            return;
        }
        if (options.replace) {
            history.replaceState({}, "", next);
        }
        else {
            history.pushState({}, "", next);
        }
        this.#setCurrent(next, true);
    }
    start() {
        if (!this.#started) {
            addEventListener("popstate", this.#handlePopState);
            this.#started = true;
        }
        this.#setCurrent(normalizePath(location.pathname), false);
        return () => {
            if (!this.#started) {
                return;
            }
            removeEventListener("popstate", this.#handlePopState);
            this.#started = false;
        };
    }
    #setCurrent(path, notifyOnlyOnChange) {
        if (notifyOnlyOnChange && path === this.#currentPath) {
            return;
        }
        this.#currentPath = path;
        this.#listener(this.#currentPath);
    }
}
export function appNameFromPath(path) {
    const match = /^\/apps\/([a-z0-9][a-z0-9-]{0,62})$/u.exec(normalizePath(path));
    return match?.[1];
}
export function pathForApp(appName) {
    return `/apps/${appName}`;
}
function normalizePath(path) {
    if (path === "/settings") {
        return path;
    }
    return /^\/apps\/[a-z0-9][a-z0-9-]{0,62}$/u.test(path) ? path : "/settings";
}
//# sourceMappingURL=stage-router.js.map